module.exports = __webpack_public_path__ + "static/media/swoosh.aad7e599.mp3";